module.exports = __webpack_public_path__ + "img/I_action.2c743c5c.png";